import { useScroll } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { MyBookPanditCategoryAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { Navigate, useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel3";
import { t } from "i18next";
const TrendingCategoriesSection = (moduleName) => {
  const [categories, setCategories] = useState([]);
  const user_id = localStorage.getItem("userID");
  const carouselRef = useRef(); // Step 1
  const { setLoader, loader, pujaStatus, setPujaStatus } =
    useContext(LoaderContext);
  const navigate = useNavigate();
  useEffect(() => {
    GetMyBookPanditCategoryData();
  }, [pujaStatus]);

  const GetMyBookPanditCategoryData = async () => {
    setLoader(true);
    const response = await MyBookPanditCategoryAPI(user_id);

    try {
      if (
        response.ResponseMessage === "list" &&
        response.ResponseCode === "0"
      ) {
        setLoader(false);
        const Data = response.DATA;
        if (pujaStatus) {
          const filteredData = Data?.filter(
            (val, index) => val?.OnlinePujaCount > 0
          );
          setCategories(filteredData);
        } else {
          const filteredData = Data?.filter(
            (val, index) => val?.OfflinePujaCount > 0
          );
          setCategories(filteredData);
        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };


  const scrollHorizontally = (direction) => {
    if (!carouselRef.current) return;
    if (direction === "left") {
      carouselRef.current.prev(); // Go to previous slide
    } else {
      carouselRef.current.next(); // Go to next slide
    }
  };

  const handleCatClick = (value) => {
    sessionStorage.setItem("selectedCatId", value?.PUJACAT_ID);
    navigate(`/services/book-puja`, {
      state: { selectedCat: value?.PUJACAT_ID },
    });
  };

  // ------------------------------

  // const options = {
  //   items: 4,
  //   loop: true,
  //   margin: 30, // ⬅️ Increased spacing between items
  //   autoWidth: true,
  //   autoplay: true,
  //   autoplayTimeout: 3000,
  //   autoplaySpeed: 1000,
  //   autoplayHoverPause: false,
  //   smartSpeed: 800,
  //   dots: false,
  //   nav: false,
  //   responsive: {
  //     0: {
  //       items: 2,
  //     },
  //     768: {
  //       items: 4,
  //     },
  //     1024: {
  //       items: 5,
  //     },
  //   },
  // };

  let options = {}
  if (categories?.length < 5) {
    options = {
      items: 4,
      loop: false,
      margin: 30, // ⬅️ Increased spacing between items

      autoplay: false,
      autoplayTimeout: 3000,
      autoplaySpeed: 1000,
      autoplayHoverPause: false,
      smartSpeed: 800,
      dots: false,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        768: {
          items: 4,
        },
        1024: {
          items: 5,
        },
      },
    };
  } else {
    options = {
      items: 4,
      loop: false,
      margin: 30, // ⬅️ Increased spacing between items
      autoWidth: true,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplaySpeed: 1000,
      autoplayHoverPause: false,
      smartSpeed: 800,
      dots: false,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        768: {
          items: 4,
        },
        1024: {
          items: 5,
        },
      },
    };
  }



  return (
    <>
      <section class="product-circle-section" style={{ background: "white" }}>
        <div class="section-title text-center">
          <h6 class="sec-title__tagline bw-split-in-right">
            <img className="tagline-img" src={placeholderImg} alt="" />
            {t("Puja Categories")}
          </h6>
          <h3 class="sec-title__title bw-split-in-left">
            {" "}
            {pujaStatus ? t("Online Puja Categories") : t("Offline Puja Categories")}
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            overflow: "visible",

          }}
        >
          {categories?.length > 3 && (
            <button
              className="carousel-arrow d-none-mobile"
              onClick={() => scrollHorizontally("left")}
              style={{
                zIndex: 2,
                border: "none",
                marginRight: "10px",
                background: "none",
                cursor: "pointer",
              }}
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
          )}

          <div style={{ width: "95%" }}>
            <OwlCarousel className="owl-theme owl-carousel-outer-custom" {...options} ref={carouselRef}>
              {categories?.map((val, index) => (
                <div
                  className="product-circle-item service-one__item trendingCatHover "
                  style={{
                    margin: 2,
                    padding: 0,
                    textAlign: "center",
                    cursor: "pointer",
                    backgroundColor: 'transparent',
                    height: '13em',

                  }}
                  onClick={() => handleCatClick(val)}
                >
                  <div className="service-one__item__icon">
                    <img
                      src={val?.PUJACAT_ICON || placeholderImg}
                      alt="careox"
                      height={50}
                      width={50}
                      style={{
                        objectFit: "cover",
                        borderRadius: "50%",
                        height: "71px", // you can adjust this size
                        width: "71px",
                        marginLeft: "7px",
                        // optional: match the dashed border in your UI
                        backgroundColor: "#f9e4e8" // optional: match the pink bg
                      }}
                    />

                  </div>
                  <p
                    className="product-label"
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      maxWidth: "100px",
                      margin: "0 auto",
                    }}
                  >
                    {val?.PUJACAT_NAME}
                  </p>
                </div>
              ))}
            </OwlCarousel>
          </div>

          {categories?.length > 3 && (
            <button
              className="carousel-arrow d-none-mobile"
              onClick={() => scrollHorizontally("right")}
              style={{
                zIndex: 2,
                border: "none",
                marginLeft: "10px",
                background: "none",
                cursor: "pointer",
              }}
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          )}
        </div>
      </section>
    </>
  );
};

export default TrendingCategoriesSection;